module.exports = __webpack_public_path__ + "static/media/logo-UNICARIBE-2.e6cc5741.png";